export { default } from "./Flex";
export { type FlexProps } from "./styled";
